


/**
 * EasyHTTP Library
 * Library for making HTTP requests
 * @author SuperManic
 *
 */

const { getAccessToken, refreshAccessToken } = require("../auth/session");

let api_origin = process.env.REACT_APP_BASE_API_URL;

/*
 * fetch with the talent's stored access token. On a 401 the token is
 * refreshed once and the request is sent again. The token never comes from
 * the URL: src/lib/auth/session.ts takes it out of the address bar at start-up.
 */
async function fetchWithSession(url, options, fallbackToken) {
    const send = (token) => fetch(`${api_origin}${url}`, {
        ...options,
        headers: { ...options.headers, 'Authorization': `Bearer ${token}` }
    })

    let res = await send(getAccessToken() || fallbackToken)
    if (res.status === 401) {
        const newToken = await refreshAccessToken()
        if (newToken) {
            res = await send(newToken)
        }
    }
    return res
}

class EasyHTTP {

    async getNoAuth(url) {

        try {
            const res = await fetch(`${api_origin}${url}`, {

                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                }
            })

            const resData = await res.json()
            return resData
        } catch (e) {
            // throw new Error(e.message)
            console.log(e.message)
        }
    }

    async get(url, Token) {
        try {
            const res = await fetchWithSession(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                }
            }, Token)

            const resData = await res.json()
            return resData
        } catch (e) {
            // throw new Error(e.message)
            console.log(e.message)
        }
    }

    // Make an HTTP POST Request
    async post(url, data, userToken) {
        try {
            const res = await fetchWithSession(url, {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify(data) //convert to JSON string
            }, userToken)
            const postedData = await res.json()
            return postedData

        } catch (e) {
            // throw new Error(e.message)
            console.log(e.message)
        }
    }
    // POST WITHOUT AUTH

    async postNoAuth(url, data) {

        try {
            const res = await fetch(`${api_origin}${url}`, {
                mode: 'cors',
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',

                },
                body: JSON.stringify(data) //convert to JSON string
            })
            const postedData = await res.json()
            return postedData

        } catch (e) {
            // throw new Error(e.message)
            console.log(e.message)
        }
    }
    // Make an HTTP PUT/UPDATE Request
    async put(url, data, userToken) {
        try {
            const res = await fetchWithSession(url, {
                mode: 'cors',
                method: 'PUT',
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify(data)
            }, userToken)
            const editedData = await res.json()
            return editedData
        } catch (e) {
            // throw new Error(e.message)
            console.log(e.message)
        }
    }
    // Make an HTTP DELETE Request
    async delete(url) {
        try {
            const res = await fetch(`${api_origin}${url}`, {
                mode: 'cors',
                method: 'DELETE',
                headers: {
                    'Content-type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
            })
            const deleteRes = await 'Resource Deleted'
            return deleteRes
        } catch (e) {
            // throw new Error(e.message)
            console.log(e.message)
        }
    }
}


module.exports = EasyHTTP
